import React, { useState } from 'react';
import CalendarView from './CalendarView';
import CalendarNavigation from './CalendarNavigation';
import ChangeLogModal from './ChangeLogModal';
import { getWeekStart, addWeeksToDate, formatDateKey } from './dateUtils';

const getInitialDate = () => {
  const params = new URLSearchParams(window.location.search);
  const dateParam = params.get('week');
  if (dateParam) {
    const parsed = new Date(dateParam + 'T00:00:00');
    if (!isNaN(parsed)) return getWeekStart(parsed);
  }
  return getWeekStart(new Date());
};

const updateUrlDate = (date) => {
  const params = new URLSearchParams(window.location.search);
  params.set('week', formatDateKey(date));
  window.history.replaceState({}, '', `${window.location.pathname}?${params.toString()}`);
};

const JobCalendar = () => {
  const [startDate, setStartDate] = useState(getInitialDate);
  const [showChangeLog, setShowChangeLog] = useState(false);

  const changeDate = (date) => {
    setStartDate(date);
    updateUrlDate(date);
  };

  const handlePrevious = () => changeDate(addWeeksToDate(startDate, -1));
  const handleNext = () => changeDate(addWeeksToDate(startDate, 1));
  const handleToday = () => changeDate(getWeekStart(new Date()));
  const handleDatePick = (date) => changeDate(getWeekStart(date));

  return (
    <div>
      <CalendarNavigation
        startDate={startDate}
        onPrevious={handlePrevious}
        onNext={handleNext}
        onToday={handleToday}
        onDatePick={handleDatePick}
        onShowChangeLog={() => setShowChangeLog(true)}
      />
      <CalendarView startDate={startDate} />
      {showChangeLog && (
        <ChangeLogModal onClose={() => setShowChangeLog(false)} />
      )}
    </div>
  );
};

export default JobCalendar;
